(function(){
  function ready(fn){ if(document.readyState!=='loading') fn(); else document.addEventListener('DOMContentLoaded',fn); }
  ready(function(){
    var els=document.querySelectorAll('.x-reveal');
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
      },{threshold:.12,rootMargin:'0px 0px -40px 0px'});
      els.forEach(function(el){ io.observe(el); });
    } else { els.forEach(function(el){ el.classList.add('is-in'); }); }

    var header=document.querySelector('.x-header');
    var sticky=document.querySelector('.x-sticky');
    var hero=document.querySelector('.x-hero');
    function onScroll(){
      var y=window.scrollY||0;
      if(header) header.classList.toggle('is-scrolled',y>8);
      if(sticky){
        var limit=hero?hero.offsetTop+hero.offsetHeight*0.7:500;
        var nearEnd=(window.innerHeight+y)>=(document.body.scrollHeight-260);
        sticky.classList.toggle('is-visible',y>limit && !nearEnd);
      }
    }
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();

    document.querySelectorAll('[data-x-vsl]').forEach(function(btn){
      btn.addEventListener('click',function(){
        var box=btn.closest('.x-vsl-inner'); var src=btn.getAttribute('data-x-vsl');
        if(!box||!src) return;
        var f=document.createElement('iframe');
        f.src=src; f.allow='autoplay; encrypted-media; picture-in-picture; fullscreen'; f.allowFullscreen=true; f.title='Wideo';
        box.innerHTML=''; box.appendChild(f);
      });
    });

    document.querySelectorAll('[data-x-carousel]').forEach(function(c){
      var track=c.querySelector('.x-track'); if(!track) return;
      function step(){ var s=track.querySelector('.x-story'); return s? s.getBoundingClientRect().width+16 : 300; }
      var p=c.querySelector('[data-x-prev]'), n=c.querySelector('[data-x-next]');
      if(p) p.addEventListener('click',function(){ track.scrollBy({left:-step(),behavior:'smooth'}); });
      if(n) n.addEventListener('click',function(){ track.scrollBy({left:step(),behavior:'smooth'}); });
    });

    document.querySelectorAll('[data-x-wall-toggle]').forEach(function(b){
      var wall=document.getElementById(b.getAttribute('data-x-wall-toggle'));
      if(!wall) return;
      var label=b.querySelector('span');
      var openTxt=b.getAttribute('data-open')||'Pokaż mniej', closedTxt=label.textContent;
      function check(){ if(!wall.classList.contains('is-open') && wall.scrollHeight<=wall.clientHeight+10){ wall.classList.add('is-open'); b.parentNode.style.display='none'; } }
      window.addEventListener('load',check); check();
      b.addEventListener('click',function(){
        var o=wall.classList.toggle('is-open');
        label.textContent=o?openTxt:closedTxt;
        if(!o) wall.scrollIntoView({behavior:'smooth',block:'start'});
      });
    });
    var lb=document.querySelector('.x-lightbox');
    if(lb){
      document.body.appendChild(lb);
      var lbImg=lb.querySelector('img');
      function close(){ lb.classList.remove('is-open'); document.body.style.overflow=''; }
      document.querySelectorAll('[data-x-full]').forEach(function(w){
        w.addEventListener('click',function(){ lbImg.src=w.getAttribute('data-x-full'); lb.classList.add('is-open'); document.body.style.overflow='hidden'; });
      });
      lb.addEventListener('click',function(e){ if(e.target===lb||e.target.closest('.x-lightbox-close')) close(); });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape') close(); });
    }
  });
})();
